module.exports = __webpack_public_path__ + "static/img/znsb_bg_watch.d6b2de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/znsb_bg_watch.png
// module id = G/Yc
// module chunks = 21